import React, { useEffect } from 'react';
import { useAtom } from 'jotai';
import { authStepAtom, authRedirectToAtom } from 'auth/atoms';
import IdentifierStep from 'components/auth/components/IdentifierStep';
import VerificationStep from 'components/auth/components/VerificationStep';
import SignupDetailsStep from 'components/auth/components/SignupDetailsStep';
import { useRouter } from 'next/router';

const AuthSteps = () => {
  const [step] = useAtom(authStepAtom);
  const [, setRedirectTo] = useAtom(authRedirectToAtom);
  const router = useRouter();

  useEffect(() => {
    const redirect_to = router.query.redirect_to as string | undefined;
    setRedirectTo(redirect_to || '/');
  }, [router.query.redirect_to, setRedirectTo]);

  return (
    <>
      {step === 'identifier' && <IdentifierStep />}
      {step === 'verification' && <VerificationStep />}
      {step === 'signupDetails' && <SignupDetailsStep />}
    </>
  );
};

export default AuthSteps;
